
import React from 'react';
import { Search, Filter } from 'lucide-react';

interface SearchFilterOverlayProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  selectedFilter: string;
  setSelectedFilter: (filter: string) => void;
  showFilters: boolean;
  setShowFilters: (show: boolean) => void;
}

export default function SearchFilterOverlay({
  searchTerm,
  setSearchTerm,
  selectedFilter,
  setSelectedFilter,
  showFilters,
  setShowFilters
}: SearchFilterOverlayProps) {
  const filters = ['All', 'Personal', 'Community', 'Urgent', 'Answered'];

  return (
    <div className="absolute bottom-0 left-0 right-0 px-4 pb-6 pt-8 bg-gradient-to-t from-black/50 to-transparent">
      <div className="space-y-4">
        <div className="flex gap-2">
          <div className="flex-1 relative">
            <Search size={20} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-white/70" />
            <input
              type="text"
              placeholder="Search prayers..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-10 pr-4 py-3 border border-white/20 rounded-lg focus:outline-none focus:ring-2 focus:ring-white/30 text-base bg-white/10 backdrop-blur-sm text-white placeholder-white/70"
            />
          </div>
          <button 
            onClick={() => setShowFilters(!showFilters)}
            className="p-3 border border-white/20 rounded-lg bg-white/10 backdrop-blur-sm text-white hover:bg-white/20 transition-colors"
          >
            <Filter size={20} />
          </button>
        </div>

        {showFilters && (
          <div className="flex gap-2 overflow-x-auto pb-2 md:flex-wrap md:overflow-visible">
            {filters.map((filter) => (
              <button
                key={filter}
                onClick={() => setSelectedFilter(filter)}
                className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors backdrop-blur-sm md:px-4 md:py-2 md:text-base ${
                  selectedFilter === filter 
                    ? 'bg-white text-black' 
                    : 'bg-white/20 text-white border border-white/30 hover:bg-white/30'
                }`}
              >
                {filter}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
